import { render, staticRenderFns } from "./AutoMail.vue?vue&type=template&id=231ec8a8&scoped=true"
import script from "./AutoMail.vue?vue&type=script&lang=js"
export * from "./AutoMail.vue?vue&type=script&lang=js"
import style0 from "./AutoMail.vue?vue&type=style&index=0&id=231ec8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231ec8a8",
  null
  
)

export default component.exports